import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark-filled-icon_f26d26a96f22762b098217b36e7ebcbc",
  "use": "bookmark-filled-icon_f26d26a96f22762b098217b36e7ebcbc-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bookmark-filled-icon_f26d26a96f22762b098217b36e7ebcbc\">\n<path d=\"M11.3334 2H4.66671C3.93337 2 3.33337 2.6 3.33337 3.33333V14L8.00004 12L12.6667 14V3.33333C12.6667 2.6 12.0667 2 11.3334 2ZM11.3334 12L8.00004 10.5467L4.66671 12V3.33333H11.3334V12Z\" />\n<path d=\"M11.3334 12L8.00004 10.5467L4.66671 12V3.33333H11.3334V12Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol